import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslations } from 'next-intl'
import { Link } from '@assets-components'
import { Icon, Image, ImageData } from '@media-components'
import { CustomStyles, getStyles, useScreenSize } from '@utils/styles'
import { ActionButtonData } from '../ActionButton'
import defaultStyles, { StylesClassNames } from './styles'

export type PostCardProps = {
  createdAt: string
  imageUrl: string
  title: string
  description: string
  categories?: {
    id: string
    name: string
    slug: string
  }[]
  date: string
  time: string
  tag?: string
  href: string
  authorProfile: {
    authorName: string
    authorDescription?: string
    authorDesignation?: string
    authorImage?: ImageData
    knowsAbout?: string[]
    linkedInUrl?: string
    twitterUrl?: string
    instagramUrl?: string
    facebookUrl?: string
    authorSlug?: string
    authorInstagramUrl?: string
    authorTwitterUrl?: string
  }
  isExpanded?: boolean
  customStyles?: CustomStyles<StylesClassNames>
  orientation?: 'vertical' | 'horizontal'
  actionButtonData?: ActionButtonData
  logoData?: ImageData
  caseStudyDateRange?: string
}

export function PostCard({
  createdAt,
  imageUrl,
  title,
  description,
  time,
  date,
  href,
  customStyles,
}: PostCardProps) {
  const styles = getStyles(defaultStyles, customStyles)

  const { screen } = useScreenSize()
  const t = useTranslations('RecentPost')
  return (
    <Link
      href={href}
      style={{
        textDecoration: 'none',
        flexBasis: screen === 'lg' ? '48.5%' : '100%',
      }}
      key={createdAt.toString()}
    >
      <Box {...styles('cardWrapper')}>
        <Box {...styles('imageStyles')}>
          <Image src={imageUrl} alt="image" />
        </Box>
        <Box {...styles('content')}>
          <Box {...styles('titleDesc')}>
            {/* {category && (
              <Typography
                variant="caption2.600"
                color="blue.600"
                {...styles('tag')}
              >
                {category}
              </Typography>
            )} */}
            <Typography variant="h6.600" color="grey.950">
              {title}
            </Typography>
            <Typography
              color="grey.500"
              variant="body1.400"
              {...styles('description')}
            >
              {description}
            </Typography>
            {/* <Box {...styles('author')}>
              <Image
                src="/images/enquiry-Image-temp.png"
                alt="image"
                {...styles('authorIcon')}
              />
              <Typography variant="body2.500" color="grey.500">
                {`By <${author}>`}
              </Typography>
            </Box> */}
          </Box>
          <Box {...styles('updated')}>
            <Box {...styles('time')}>
              <Typography variant="caption1.500" color="grey.500">
                {time}
              </Typography>
              <Box component="p" {...styles('dot')} />
              <Typography variant="caption1.500" color="grey.500">
                {date}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: 'grey.500',
              }}
            >
              <Typography variant="body3.400" color="grey.500">
                {t('readMore')}
              </Typography>
              <Icon
                iconName="ArrowRight"
                fontSize="extraSmall"
                colorValues="grey.500"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Link>
  )
}
